import React from 'react';


interface StoreButtonProps {
  type: 'apple' | 'google';
  url?: string;
  className?: string;
}

const StoreButton: React.FC<StoreButtonProps> = ({ type, url, className = '' }) => {
  const isApple = type === 'apple';
  const imagePath = isApple ? '/apple-store.svg' : '/google-play.svg';
  return (
    <a
      href={url}
      target='_blank'
      className={`
        group relative px-4 py-2 md:px-6 md:py-3 rounded-xl font-medium
        transition-all duration-300 ease-in-out
        transform hover:scale-105 hover:-translate-y-1
        ${isApple
          ? 'bg-black text-white'
          : 'bg-orcsys-500 text-white border border-orcsys-500 hover:border-orcsys-500'
        }
        ${className}
      `}
    >
      {/* Content */}
      <div className="relative flex items-center justify-center w-full gap-3">
        <img
          src={imagePath}
          alt={isApple ? 'App Store' : 'Google Play'}
          className={`
            transition-colors duration-300
            ${isApple
              ? 'w-7 h-7 brightness-0 invert group-hover:brightness-0 group-hover:invert'
              : 'w-6 h-6 brightness-0 invert group-hover:brightness-0 group-hover:invert'
            }
          `}
        />
        <div className="text-left">
          <div className="text-xs opacity-80">{isApple ? 'Télécharger sur' : 'Disponible sur'}</div>
          <div className="text-sm font-semibold">
            {isApple ? 'App Store' : 'Google Play'}
          </div>
        </div>
      </div>
    </a>
  );
};

export default StoreButton; 